import { FormHelperText, styled } from "@mui/material"

export const StyledFormTextHelper = styled(FormHelperText)(() => ({
    margin: "3px 14px 0",
}))
